export function formatNumber(num, digits = 2) {
  return num ? (+num).toFixed(digits).replace(/(\.0*|(?:\/(\..*))0*)$/, '') : '0'
}
export function formatAsPercentage(num, digits = 2) {
  return num ? formatNumber(num, digits) + '%' : '0%'
}
